// Sold out today (docs/plans/menu-sections.md): a dish marked sold out comes back by itself
// at the next 05:00 on this device's clock, so a late service is not cut off at midnight.
// On devices it is a hint; only the guest's order is refused by the server.

/** The hour a sold-out dish is back on the menu. */
export const BACK_ON_HOUR = 5

/** When a dish marked now comes back: the next 05:00 (today's, when it is not 05:00 yet). */
export function soldOutUntil(now: Date = new Date()): string {
  const back = new Date(now)
  back.setHours(BACK_ON_HOUR, 0, 0, 0)
  if (back <= now) back.setDate(back.getDate() + 1)
  return back.toISOString()
}

/** Whether a dish is sold out at `now`. */
export function isSoldOut(p: { sold_out_until?: string | null }, now: Date = new Date()): boolean {
  return !!p.sold_out_until && new Date(p.sold_out_until).getTime() > now.getTime()
}
